/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Mateusz Janeczek <mj@giap.pl>, February 2017
 * Contributors: Krzysztof Gregorowicz <gregorowicz.k@gmail.com>
 */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import s from './ImportEksport.scss';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import { Checkbox, FormGroup } from 'react-bootstrap';
import Modal from 'react-bootstrap/lib/Modal';
import { propertiesMap, propertiesPattern, layersMap, layersPattern } from '../../../../../data/propertiesMap';

import ModalAlert from '../../../ModalAlert';
import SelectFile from '../../../../SelectFile';

import { postSHPinZIP, getPostSHPStatus, postSHPfiles, postCSV, postGML, postSQLite, postApprovedSQLite } from '../../../../../actions/postGeoData';
import { fetchPgLayersList } from '../../../../../actions/district';
import DropFile from '../../../../DropFile';

class SHP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: 0,
    };
  }
  podMenu = () => {
    let i = null;
    switch (this.state.menu) {
      case 0:
        i = null;
        break;
      case 1:
        i = (
          <SHPMenu1
            postSHPinZIP={this.props.postSHPinZIP}
            district={this.props.district}
            getPostSHPStatus={this.props.getPostSHPStatus}
            fetchPgLayersList={this.props.fetchPgLayersList}
          />);
        break;
      case 2:
        i = (
          <SHPMenu2
            district={this.props.district}
            postSHPfiles={this.props.postSHPfiles}
            getPostSHPStatus={this.props.getPostSHPStatus}
            fetchPgLayersList={this.props.fetchPgLayersList}
          />);
        break;
      default:
        i = (
          <SHPMenu2
            district={this.props.district}
            postSHPfiles={this.props.postSHPfiles}
            getPostSHPStatus={this.props.getPostSHPStatus}
            fetchPgLayersList={this.props.fetchPgLayersList}
          />);
        break;
    }
    return i;
  }
  handleClick1 = () => {
    this.setState({ menu: 1 });
  }
  handleClick2 = () => {
    this.setState({ menu: 2 });
  }
  render() {
    const a1 = this.state.menu === 1 ? 'btn btn-primary active' : 'btn btn-primary';
    const a2 = this.state.menu === 2 ? 'btn btn-primary active' : 'btn btn-primary';
    return (
      <div className="content">
        <br />Pliki .SHP<br />
        <div className="row">
          <div className="btn-group">
            <button type="button" className={a1} onClick={this.handleClick1}>Pliki SHP spakowane</button>
            <button type="button" className={a2} onClick={this.handleClick2}>Pliki SHP</button>
          </div>
        </div><br />
        {this.podMenu()}
      </div>
    )
  }
}

class SHPMenu1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      fileName: null,
      fileList: null,
      isFileSelected: false,
      modalTitle: '',
      modalBody: '',
      postStatus: 0,
      showStatus: false,
      layerName: '',
      layerEPSG: 2180,
      shouldReset: false,
    };
  }

  onFileSelect = (inputState) => this.setState({ ...inputState, shouldReset: false });
  onSend = () => {
    if (!this.state.fileName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż spakowany plik shp', showModal: true });
    } else if (!this.state.layerName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij szczegóły tworzonej warstwy.', showModal: true });
    } else {
      this.props.postSHPinZIP(this.props.district.prefix, this.state.layerName, this.state.layerEPSG, this.state.fileList)
      .then((resp) => {
        (resp.status === 200) ? this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus(resp.request_id)) : null;
      });
    }
  }

  onChangeLayerName = (e) => this.setState({ layerName: e.target.value });
  onChangeLayerEPSG = (e) => this.setState({ layerEPSG: e.target.value });
  dismissModalStatus = () => this.setState({ showStatus: false });

  animateStatus = (request_id) => {
    this.props.getPostSHPStatus(request_id).then((resp) => {
      if (this.state.showStatus && resp.status !== 'finished') {
        setTimeout(() => {
          const status = (this.state.postStatus <= 95) ? this.state.postStatus + 5 : 100;
          this.setState({ postStatus: status }, () => this.animateStatus(request_id));
        }, 200);
      } else {
        const odp = (resp.status === 'failed') ? 'Upsss.... coś poszło nie tak' : 'Pomyślnie dodano nową tablicę w bazie danych.';
        this.setState({
          showStatus: false,
          modalTitle: 'Status',
          modalBody: odp,
          showModal: true,
          shouldReset: true,
          layerName: '',
          layerEPSG: 2180,
        }, () => this.props.fetchPgLayersList(this.props.district.prefix).then(() => this.setState({ shouldReset: false })));
      }
    });
  }
  dismissModal = () => this.setState({ showModal: false });

  render() {
    return (
      <div className="content">
        <div className="layerDetails">
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerName">Nazwa warstwy</label>
            <input className="form-control" name="layerName" value={this.state.layerName} onChange={(e) => this.onChangeLayerName(e)} />
          </div>
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerEPSG">EPSG (np. 2180)</label>
            <input className="form-control" name="layerEPSG" value={this.state.layerEPSG} onChange={(e) => this.onChangeLayerEPSG(e)} />
          </div>
        </div>
        <SelectFile
          shouldReset={this.state.shouldReset}
          accept=".zip"
          btnText=".ZIP"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onFileSelect(inputState)}
        />
        <button onClick={() => this.onSend()} type="button" className="btn btn-primary">Wyślij</button>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        <br /><br />
        {this.state.showStatus ? <ProgressBar active now={this.state.postStatus} /> : null}
      </div>
    );
  }
}

class SHPMenu2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shp: {
        fileName: null,
        fileList: null,
        isFileSelected: false,
      },
      shx: {
        fileName: null,
        fileList: null,
        isFileSelected: false,
      },
      dbf: {
        fileName: null,
        fileList: null,
        isFileSelected: false,
      },
      showModal: false,
      modalTitle: '',
      modalBody: '',
      postStatus: 0,
      showStatus: false,
      layerName: '',
      layerEPSG: 2180,
      shouldDbfReset: false,
      shouldShpReset: false,
      shouldShxReset: false,
    };
  }

  onShpSelect = (inputState) => this.setState({ shp: { ...inputState }, shouldShpReset: false });
  onShxSelect = (inputState) => this.setState({ shx: { ...inputState }, shouldShxReset: false });
  onDbfSelect = (inputState) => this.setState({ dbf: { ...inputState }, shouldDbfReset: false });

  onSend = () => {
    let isOK = true;
    if (!this.state.layerName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij szczegóły tworzonej warstwy.', showModal: true });
    }
    if (!this.state.shp.fileName || !this.state.shp.fileList) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż spakowany plik shp', showModal: true });
      isOK = false;
    }
    if (!this.state.shx.fileName || !this.state.shx.fileList) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż spakowany plik shx', showModal: true });
      isOK = false;
    }
    if (!this.state.dbf.fileName || !this.state.dbf.fileList) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż spakowany plik dbf', showModal: true });
      isOK = false;
    }
    if (!this.state.layerName || !this.state.layerEPSG) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij szczegóły warstwy', showModal: true });
      isOK = false;
    }
    if (isOK) {
      this.props.postSHPfiles(
                              this.props.district.prefix,
                              this.state.layerName,
                              this.state.layerEPSG,
                              this.state.shp.fileList,
                              this.state.shx.fileList,
                              this.state.dbf.fileList)
      .then((resp) => {
        (resp.status === 200) ? this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus(resp.request_id)) : null;
      });
      this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus());
    }
  }

  onChangeLayerName = (e) => this.setState({ layerName: e.target.value });
  onChangeLayerEPSG = (e) => this.setState({ layerEPSG: e.target.value });
  dismissModal = () => this.setState({ showModal: false });
  dismissModalStatus = () => this.setState({ showStatus: false });

  animateStatus = (request_id) => {
    this.props.getPostSHPStatus(request_id).then((resp) => {
      if (this.state.showStatus && resp.status !== 'finished') {
        setTimeout(() => {
          const status = (this.state.postStatus <= 95) ? this.state.postStatus + 5 : 100;
          this.setState({ postStatus: status }, () => this.animateStatus(request_id));
        }, 200);
      } else {
        const odp = (resp.status === 'failed') ? 'Upsss.... coś poszło nie tak' : 'Pomyślnie dodano nową tablicę w bazie danych.';
        this.setState({
          showStatus: false,
          modalTitle: 'Status',
          modalBody: odp,
          showModal: true,
          shp: {
            fileName: null,
            fileList: null,
            isFileSelected: false,
          },
          shx: {
            fileName: null,
            fileList: null,
            isFileSelected: false,
          },
          dbf: {
            fileName: null,
            fileList: null,
            isFileSelected: false,
          },
          shouldDbfReset: true,
          shouldShpReset: true,
          shouldShxReset: true,
          postStatus: 0,
          layerName: '',
        }, () => this.props.fetchPgLayersList(this.props.district.prefix).then(() => this.setState({ shouldDbfReset: false, shouldShpReset: false, shouldShxReset: false })));
      }
    });
  }

  render() {
    return (
      <div className="content">
        <div className="layerDetails">
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerName">Nazwa warstwy</label>
            <input className="form-control" name="layerName" value={this.state.layerName} onChange={(e) => this.onChangeLayerName(e)} />
          </div>
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerEPSG">EPSG (np. 2180)</label>
            <input className="form-control" name="layerEPSG" value={this.state.layerEPSG} onChange={(e) => this.onChangeLayerEPSG(e)} />
          </div>
        </div>
        <SelectFile
          shouldReset={this.state.shouldShpReset}
          accept=".shp"
          btnText=".SHP"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onShpSelect(inputState)}
        />
        <SelectFile
          shouldReset={this.state.shouldShxReset}
          accept=".shx"
          btnText=".SHX"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onShxSelect(inputState)}
        />
        <SelectFile
          shouldReset={this.state.shouldDbfReset}
          accept=".dbf"
          btnText=".DBF"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onDbfSelect(inputState)}
        />
        <button onClick={() => this.onSend()} type="button" className="btn btn-primary">Wyślij</button>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        {this.state.showStatus ? <ProgressBar active now={this.state.postStatus} /> : null}
      </div>
    );
  }
}

class GML extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      gml: {
        fileName: null,
        fileList: null,
        isFileSelected: false,
      },
      gfs: {
        fileName: null,
        fileList: null,
        isFileSelected: false,
      },
      modalTitle: '',
      modalBody: '',
      postStatus: 0,
      showStatus: false,
      layerName: '',
      layerEPSG: 2180,
      shouldResetGML: false,
      shouldResetGFS: false,
    };
  }

  onSelectGML = (inputState) => this.setState({ gml: { ...inputState }, shouldResetGML: false });
  onSelectGFS = (inputState) => this.setState({ gfs: { ...inputState }, shouldResetGFS: false });

  onSend = () => {
    let isOk = true;
    if (!this.state.gml.fileName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż plik gml.', showModal: true });
      isOk = false;
    } else if (!this.state.gfs.fileName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż plik gfs.', showModal: true });
      isOk = false;
    } else if (!this.state.layerName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij szczegóły tworzonej warstwy.', showModal: true });
    } else {
      this.props.postGML(
                        this.props.district.prefix,
                        this.state.layerName,
                        this.state.layerEPSG,
                        this.state.gml.fileList,
                        this.state.gfs.fileList)
      .then((resp) => {
        (resp.status === 200) ? this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus(resp.request_id)) : null;
      });
      //this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus());
    }
  }
  onChangeLayerName = (e) => this.setState({ layerName: e.target.value });
  onChangeLayerEPSG = (e) => this.setState({ layerEPSG: e.target.value });
  dismissModalStatus = () => this.setState({ showStatus: false });

  animateStatus = (request_id) => {
    this.props.getPostSHPStatus(request_id).then((resp) => {
      if (this.state.showStatus && resp.status !== 'finished') {
        setTimeout(() => {
          const status = (this.state.postStatus <= 95) ? this.state.postStatus + 5 : 100;
          this.setState({ postStatus: status }, () => this.animateStatus(request_id));
        }, 200);
      } else {
        const odp = (resp.status === 'failed') ? 'Upsss.... coś poszło nie tak' : 'Pomyślnie dodano nową tablicę w bazie danych.';
        this.setState({
          showStatus: false,
          modalTitle: 'Status',
          modalBody: odp,
          showModal: true,
          shouldResetGFS: true,
          shouldResetGML: true,
          gml: {
            fileName: null,
            fileList: null,
            isFileSelected: false,
          },
          gfs: {
            fileName: null,
            fileList: null,
            isFileSelected: false,
          },
          layerName: '',
          layerEPSG: 2180,
        }, () => this.props.fetchPgLayersList(this.props.district.prefix).then(() => this.setState({ shouldResetGFS: false, shouldResetGML: false })));
      }
    });
  }
  dismissModal = () => this.setState({ showModal: false });

  render() {
    return (
      <div className="content">
        <div className="layerDetails">
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerName">Nazwa warstwy</label>
            <input className="form-control" name="layerName" value={this.state.layerName} onChange={(e) => this.onChangeLayerName(e)} />
          </div>
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerEPSG">EPSG (np. 2180)</label>
            <input className="form-control" name="layerEPSG" value={this.state.layerEPSG} onChange={(e) => this.onChangeLayerEPSG(e)} />
          </div>
        </div>
        <br />Pliki .GML<br />
        <SelectFile
          shouldReset={this.state.shouldResetGML}
          accept=".gml"
          btnText=".GML"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onSelectGML(inputState)}
        />
        <SelectFile
          shouldReset={this.state.shouldResetGFS}
          accept=".gfs"
          btnText=".GFS"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onSelectGFS(inputState)}
        />
        <button onClick={() => this.onSend()} type="button" className="btn btn-primary">Wyślij</button>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        {this.state.showStatus ? <ProgressBar active now={this.state.postStatus} /> : null}
      </div>
    );
  }
}

class CSV extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      fileName: null,
      fileList: null,
      isFileSelected: false,
      modalTitle: '',
      modalBody: '',
      postStatus: 0,
      showStatus: false,
      layerName: '',
      layerEPSG: 2180,
      shouldReset: false,
    };
  }

  onFileSelect = (inputState) => this.setState({ ...inputState, shouldReset: false });

  onSend = () => {
    if (!this.state.fileName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż plik CSV.', showModal: true });
    } else if (!this.state.layerName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij szczegóły tworzonej warstwy.', showModal: true });
    } else {
      this.props.postCSV(this.props.district.prefix, this.state.layerName, this.state.layerEPSG, this.state.fileList)
      .then((resp) => {
        (resp.status === 200) ? this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus(resp.request_id)) : null
      })
      .catch((error) => {
        error.text().then(errorMessage => this.setState({
          modalTitle: 'Status',
          modalBody: errorMessage,
          showModal: true
        }));
      });
    }
  }
  onChangeLayerName = (e) => this.setState({ layerName: e.target.value });
  onChangeLayerEPSG = (e) => this.setState({ layerEPSG: e.target.value });
  dismissModalStatus = () => this.setState({ showStatus: false });

  animateStatus = (request_id) => {
    this.props.getPostSHPStatus(request_id).then((resp) => {
      if (this.state.showStatus && resp.status !== 'finished') {
        setTimeout(() => {
          this.setState({ postStatus: resp.progress }, () => this.animateStatus(request_id));
        }, 200);
      } else {
        const odp = (resp.status === 'failed') ? 'Upsss.... coś poszło nie tak' : 'Pomyślnie dodano nową tablicę w bazie danych.';
        this.setState({
          postStatus: 0,
          showStatus: false,
          modalTitle: 'Status',
          modalBody: odp,
          showModal: true,
          shouldReset: true,
          layerName: '',
          layerEPSG: 2180,
        }, () => this.props.fetchPgLayersList(this.props.district.prefix).then((resp) => this.setState({ shouldReset: false, pg_layers: resp })));
      }
    });
  }
  dismissModal = () => this.setState({ showModal: false });

  render() {
    return (
      <div className="content">
        <div className="layerDetails">
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerName">Nazwa warstwy</label>
            <input className="form-control" name="layerName" value={this.state.layerName} onChange={(e) => this.onChangeLayerName(e)} />
          </div>
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerEPSG">EPSG (np. 2180)</label>
            <input className="form-control" name="layerEPSG" value={this.state.layerEPSG} onChange={(e) => this.onChangeLayerEPSG(e)} />
          </div>
        </div>
        <br />Pliki .CSV<br />
        <DropFile
          accept="text/csv"
          labelType="default"
          multiple={false}
          onFileSelect={(inputState) => this.onFileSelect(inputState)}
          shouldReset={this.state.shouldReset}
        />
        <button onClick={() => this.onSend()} type="button" className="btn btn-primary" style={{marginBottom: '10px'}}>Wyślij</button>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        {this.state.showStatus ? <ProgressBar active now={this.state.postStatus} /> : null}
      </div>
    );
  }
}

class SQLite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      fileName: null,
      fileList: null,
      isFileSelected: false,
      modalTitle: '',
      modalBody: '',
      postStatus: 0,
      showStatus: false,
      layerName: '',
      layerEPSG: 2180,
      shouldReset: false,
      sqliteLayers: null,
      isCheckingSQLiteFile: false,
    };
  }

  onFileSelect = (inputState) => {
    this.setState({ ...inputState, shouldReset: false, isCheckingSQLiteFile: true }, () => {
      this.props.postSQLite(this.props.district.prefix, this.state.fileList)
        .then(resp => {
          this.setState({ sqliteLayers: resp.msg, isCheckingSQLiteFile: false });
        },
      );
    });
  };

  onSend = () => {
    if (!this.state.fileName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż plik SQLite.', showModal: true });
    } else if (!this.state.layerName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij szczegóły tworzonej warstwy.', showModal: true });
    } else {
      this.props.postApprovedSQLite(this.props.district.prefix, JSON.stringify(this.state.sqliteLayers))
        .then((resp) => {
          (resp.status === 200) ? this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus(resp.request_id)) : null;
        });
    }
  }
  onChangeLayerName = (e) => this.setState({ layerName: e.target.value });
  onChangeLayerEPSG = (e) => this.setState({ layerEPSG: e.target.value });
  dismissModalStatus = () => this.setState({ showStatus: false });

  animateStatus = (request_id) => {
    this.props.getPostSHPStatus(request_id).then((resp) => {
      if (this.state.showStatus && resp.status !== 'finished') {
        setTimeout(() => {
          const status = (this.state.postStatus <= 95) ? this.state.postStatus + 5 : 100;
          this.setState({ postStatus: status }, () => this.animateStatus(request_id));
        }, 200);
      } else {
        const odp = (resp.status === 'failed') ? 'Upsss.... coś poszło nie tak' : 'Pomyślnie dodano nową tablicę w bazie danych.';
        this.setState({
          showStatus: false,
          modalTitle: 'Status',
          modalBody: odp,
          showModal: true,
          shouldReset: true,
          layerName: '',
          layerEPSG: 2180,
        }, () => this.props.fetchPgLayersList(this.props.district.prefix).then(() => this.setState({ shouldReset: false })));
      }
    });
  }
  dismissModal = () => this.setState({ showModal: false });

  handleChange = (e, item) => {
    this.setState({
      sqliteLayers: {
        ...this.state.sqliteLayers,
        [item]: {
          ...this.state.sqliteLayers[item],
          isApproved: !this.state.sqliteLayers[item].isApproved,
        },
      },
    });
  };

  handleSridChange = (e, item, i) => {
    this.setState({
      sqliteLayers: {
        ...this.state.sqliteLayers,
        [item]: {
          ...this.state.sqliteLayers[item],
          lista_geometrii: _.filter(this.state.sqliteLayers[item].lista_geometrii, (v, index) => {
            if (i === index) {
              v.srid = e.target.value;
              return v;
            }
            return v;
          }),
        },
      },
    });
  };

  render() {
    return (
      <div className="content">
        <br />Pliki .SQlite<br />
        <SelectFile
          shouldReset={this.state.shouldReset}
          accept=".sqlite"
          btnText=".sqlite"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onFileSelect(inputState)}
        />
        {this.state.isCheckingSQLiteFile === true ? <p><i className="fa fa-spinner fa-pulse fa-2x fa-fw"></i></p> : null}
        {this.state.isCheckingSQLiteFile === false && this.state.sqliteLayers !== null ?
          <div className="col-xs-12" style={{ color: 'black'}}>
            <div className="col-xs-10 title-left">Warstwa</div>
            <div className="col-xs-2 title-right">Importuj</div>
            {Object.keys(this.state.sqliteLayers).map(
              (item, index) =>
                <div key={index}>
                  <div className="col-xs-10 t-left">{String.prototype.normalizePropertiesNames(item)}</div>
                  <FormGroup className="col-xs-2 t-right" style={{marginBottom: 0}}>
                    <Checkbox
                      onChange={(e) => this.handleChange(e, item)}
                      value={item}
                      checked={this.state.sqliteLayers[item]['isApproved']}
                    />
                  </ FormGroup>
                  {this.state.sqliteLayers[item].lista_geometrii && this.state.sqliteLayers[item].lista_geometrii.length > 0 ?
                    this.state.sqliteLayers[item].lista_geometrii.map(
                      (geoItem, i) =>
                        <div key={i}>
                          <div className="col-xs-7 t-center">{geoItem.nazwa}</div>
                          <div className="col-xs-5 t-center">Epsg:&nbsp;&nbsp;
                            <input
                              className="sridInput"
                              type="text"
                              defaultValue={geoItem.srid}
                              onChange={(e) => this.handleSridChange(e, item, i)}
                            />
                          </div>
                        </div>
                    ) : null
                  }
                </div>
            )}
          </div> : null
        }
        <button onClick={() => this.onSend()} type="button" className="btn btn-primary">Wyślij</button>

        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        {this.state.showStatus ? <ProgressBar active now={this.state.postStatus} /> : null}
      </div>
    );
  }
}

class GEOTiff extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      fileName: null,
      fileList: null,
      isFileSelected: false,
      modalTitle: '',
      modalBody: '',
      postStatus: 0,
      showStatus: false,
      layerName: '',
      layerEPSG: 2180,
      shouldReset: false,
    };
  }

  onFileSelect = (inputState) => this.setState({ ...inputState, shouldReset: false });

  onSend = () => {
    if (!this.state.fileName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wskaż plik CSV.', showModal: true });
    } else if (!this.state.layerName) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij szczegóły tworzonej warstwy.', showModal: true });
    } else {
      this.props.postCSV(this.props.district.prefix, this.state.layerName, this.state.layerEPSG, this.state.fileList)
      .then((resp) => {
        (resp.status === 200) ? this.setState({ modalTitle: 'Status', showStatus: true }, () => this.animateStatus(resp.request_id)) : null;
      });
    }
  }
  onChangeLayerName = (e) => this.setState({ layerName: e.target.value });
  onChangeLayerEPSG = (e) => this.setState({ layerEPSG: e.target.value });
  dismissModalStatus = () => this.setState({ showStatus: false });

  animateStatus = (request_id) => {
    this.props.getPostSHPStatus(request_id).then((resp) => {
      if (this.state.showStatus && resp.status !== 'finished') {
        setTimeout(() => {
          const status = (this.state.postStatus <= 95) ? this.state.postStatus + 5 : 100;
          this.setState({ postStatus: status }, () => this.animateStatus(request_id));
        }, 200);
      } else {
        const odp = (resp.status === 'failed') ? 'Upsss.... coś poszło nie tak' : 'Pomyślnie dodano nową tablicę w bazie danych.';
        this.setState({
          showStatus: false,
          modalTitle: 'Status',
          modalBody: odp,
          showModal: true,
          shouldReset: true,
          layerName: '',
          layerEPSG: 2180,
        }, () => this.props.fetchPgLayersList(this.props.district.prefix).then(() => this.setState({ shouldReset: false })));
      }
    });
  }
  dismissModal = () => this.setState({ showModal: false });

  render() {
    return (
      <div className="content">
        <div className="layerDetails">
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerName">Nazwa warstwy</label>
            <input className="form-control" name="layerName" value={this.state.layerName} onChange={(e) => this.onChangeLayerName(e)} />
          </div>
          <div className="form-inline">
            <label className="nameLabel" htmlFor="layerEPSG">EPSG (np. 2180)</label>
            <input className="form-control" name="layerEPSG" value={this.state.layerEPSG} onChange={(e) => this.onChangeLayerEPSG(e)} />
          </div>
        </div>
        <br />Pliki .CSV<br />
        <SelectFile
          shouldReset={this.state.shouldReset}
          accept=".tiff"
          btnText=".TIFF"
          multiple={false}
          labelType="default"
          buttonType="info"
          onFileSelect={(inputState) => this.onFileSelect(inputState)}
        />
        <button onClick={() => this.onSend()} type="button" className="btn btn-primary">Wyślij</button>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        {this.state.showStatus ? <ProgressBar active now={this.state.postStatus} /> : null}
      </div>
    );
  }
}

class ImportEksport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ctrl: 0,
      showModal: false,
      dx: -190,
      dy: 0,
      alfa: 0,
    };
  }
  handleClick1 = () => {
    const i = 1;
    this.setState({ ctrl: i });
  }
  handleClick2 = () => {
    const i = 2;
    this.setState({ ctrl: i });
  }
  handleClick3 = () => {
    const i = 3;
    this.setState({ ctrl: i });
  }
  handleClick4 = () => {
    const i = 4;
    this.setState({ ctrl: i });
  }
  handleClick5 = () => {
    const i = 5;
    this.setState({ ctrl: i });
  }

  showProgress = () => {
    this.setState({ showModal: true }, () => this.animateCircle());
  }

  animateCircle = () => {
    if (this.state.showModal) {
      setTimeout(() => {
        let alfa = 0;
        (this.state.alfa + 5 < 360) ? alfa = this.state.alfa + 5 : alfa = 0;
        const dx = 190 * Math.sin(alfa);
        const dy = 190 * Math.cos(alfa);
        this.setState({ dx: dx, dy: dy, alfa: alfa }, () => this.animateCircle());
      }, 50);
    }
  }

  hideModal = () => this.setState({ showModal: false });

  changeMenu = () => {
    let i = null;
    switch (this.state.ctrl) {
      case 0:
        i = null;
        break;
      case 1:
        i = (
          <SHP
            postSHPinZIP={this.props.postSHPinZIP}
            district={this.props.district}
            getPostSHPStatus={this.props.getPostSHPStatus}
            fetchPgLayersList={this.props.fetchPgLayersList}
            postSHPfiles={this.props.postSHPfiles}
          />);
        break;
      case 2:
        i = (
          <GML
            district={this.props.district}
            fetchPgLayersList={this.props.fetchPgLayersList}
            getPostSHPStatus={this.props.getPostSHPStatus}
            postGML={this.props.postGML}
          />);
        break;
      case 3:
        i = (
          <CSV
            district={this.props.district}
            fetchPgLayersList={this.props.fetchPgLayersList}
            getPostSHPStatus={this.props.getPostSHPStatus}
            postCSV={this.props.postCSV}
          />);
        break;
      case 4:
        i = (
          <SQLite
            district={this.props.district}
            fetchPgLayersList={this.props.fetchPgLayersList}
            getPostSHPStatus={this.props.getPostSHPStatus}
            postSQLite={this.props.postSQLite}
            postApprovedSQLite={this.props.postApprovedSQLite}
          />);
      case 5:
        i = (
          <GEOTiff
            district={this.props.district}
            fetchPgLayersList={this.props.fetchPgLayersList}
            getPostSHPStatus={this.props.getPostSHPStatus}
            postSQLite={this.props.postSQLite}
            postApprovedSQLite={this.props.postApprovedSQLite}
          />);
        break;
      default:
        i = <CSV />;
        break;
    }
    return i;
  }
  render() {
    const a1 = this.state.ctrl === 1 ? 'btn btn-primary active' : 'btn btn-primary';
    const a2 = this.state.ctrl === 2 ? 'btn btn-primary active' : 'btn btn-primary';
    const a3 = this.state.ctrl === 3 ? 'btn btn-primary active' : 'btn btn-primary';
    const a4 = this.state.ctrl === 4 ? 'btn btn-primary active' : 'btn btn-primary';
    return (
      <div className="container" style={{ width: '80%', textAlign: 'center' }}>
        <div id="menu" className="btn-group-justified">
          Import pliku:<br />
          <div className="row">
            <button type="button" className={a1} onClick={this.handleClick1}>SHP</button>
            <button type="button" className={a2} onClick={this.handleClick2}>GML</button>
            <button type="button" className={a3} onClick={this.handleClick3}>CSV</button>
            <button type="button" className={a4} onClick={this.handleClick4}>SQLite</button>
            <button type="button" className={a4} onClick={this.handleClick5}>GEOTiff</button>
          </div>
          {/*<div className="row">
            <button type="button" className={a3} onClick={this.showProgress}>CSV</button>
          </div>*/}
        </div>
        <div id="content2" className="row" style={{ textAlign: 'center' }} >
          {this.changeMenu()}
        </div>
        {/*<ProgressModal dx={this.state.dx} dy={this.state.dy} show={this.state.showModal} onHide={this.hideModal} />*/}
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  postSHPinZIP,
  getPostSHPStatus,
  fetchPgLayersList,
  postSHPfiles,
  postCSV,
  postGML,
  postSQLite,
  postApprovedSQLite,
};

export default withStyles(s)(connect(mapState, mapDispatch)(ImportEksport));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/ImportEksport/ImportEksport.js